import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SyncContactsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SyncContactsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const syncContacts = (request: SyncContactsRequest, options?: CashRequestOptions) =>
  post<SyncContactsRequest, SyncContactsResponse>('/2.0/cash/sync-contacts', request, {
    ...options,
    rejectOnError: true,
  })
